export default __webpack_public_path__ + "static/media/8.c665c0b9.gif";